module.exports = __webpack_public_path__ + "static/media/GroupMidLeftSuggestExamHomePage.17cb9295.svg";